import React, { useState, useEffect } from 'react';
import { Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import menuIconResource from 'assets/images/MenuIcon_Resource_inactive.svg';
import menuIconResourceActive from 'assets/images/MenuIcon_Resource_active.svg';
import menuIconApplication from 'assets/images/MenuIcon_Application.svg';
import menuIconApplicationActive from 'assets/images/MenuIcon_Application_active.svg';
import menuIconSystemActive from 'assets/images/MenuIcon_system_active.svg';
import menuIconSystem from 'assets/images/MenuIcon_system.svg';
import menuIconDashboardActive from 'assets/images/icon_dashboard_active.svg';
import menuIconDashboard from 'assets/images/icon_dashboard.svg';
import menuIconGuardrailActive from 'assets/images/icon-guardrail-active.svg';
import menuIconGuardrail from 'assets/images/icon-guardrail.svg';
import RAQNLog from 'assets/images/RAQN-Logo.svg';
import projectsIcon from 'assets/images/Projects.svg';

import { localize } from '../../locales';
import * as Permissions from '../../constants/permissions';

import './index.css';

const Sidebar = () => {
	const menu_item_application = 'application';
	const menu_item_resource = 'resource';
	const menu_item_permission = 'permission';
	const menu_item_dashboard = 'dashboard';
	const menu_item_guardrail = 'guardrail';

	const navigate = useNavigate();
	const location = useLocation();
	const [openKeys, setOpenKeys] = useState([menu_item_application]);
	const [selectedKey, setSelectedKey] = useState('application-management');

	const { permissions = [] } = useSelector((state) => state.user);

	useEffect(() => {
		// path components examples:
		// ["","application","application-management"]
		// ["","permission","role","add"]
		// special case: ["", "dashboard"]
		const pathComps = location.pathname.split('/');

		// set opened parent menu item keys
		if (pathComps.length >= 2) {
			const parentKey = pathComps[1];
			setOpenKeys((prevOpenKeys) => {
				if (!prevOpenKeys.includes(parentKey)) {
					return [...prevOpenKeys, parentKey];
				}
				return prevOpenKeys;
			});
			// special case for dashboard
			if (parentKey === menu_item_dashboard) {
				setSelectedKey(parentKey);
			}
		}
		// set selected sub-menu item keys
		if (pathComps.length >= 3) {
			const currentKey = pathComps[2];
			setSelectedKey(currentKey);
		}
		// reset
		if (pathComps.length < 2) {
			setOpenKeys([]);
			setSelectedKey(null);
		}
	}, [location.pathname]);

	const menuItems = [
		{
			key: menu_item_application,
			icon: (
				<img src={openKeys.includes(menu_item_application) ? menuIconApplicationActive : menuIconApplication} alt="" />
			),
			label: 'Application',
			children: [
				{
					key: 'application-management',
					label: 'Application Management',
					onClick: () => navigate('/application/application-management'),
					permissions: [Permissions.Application_LIST],
				},
			],
		},
		{
			key: menu_item_resource,
			icon: <img src={openKeys.includes(menu_item_resource) ? menuIconResourceActive : menuIconResource} alt="" />,
			label: 'Resource',
			children: [
				{
					key: 'knowledge-base',
					label: 'Text Base',
					onClick: () => navigate('/resource/knowledge-base'),
					permissions: [Permissions.KnowledgeBase_LIST],
				},
				{
					key: 'image-base',
					label: 'Image Base',
					onClick: () => navigate('/resource/image-base'),
					permissions: [Permissions.Image_LIST],
				},
			],
		},
		{
			key: menu_item_guardrail,
			icon: <img src={openKeys.includes(menu_item_guardrail) ? menuIconGuardrailActive : menuIconGuardrail} alt="" />,
			label: 'Guardrail',
			children: [
				{
					key: 'content-review',
					label: 'Content Review',
					onClick: () => navigate('/guardrail/content-review'),
					permissions: [Permissions.ContentReview_LIST],
				},
			],
		},
		{
			key: menu_item_dashboard,
			icon: <img src={selectedKey === menu_item_dashboard ? menuIconDashboardActive : menuIconDashboard} alt="" />,
			label: 'Dashboard',
			onClick: () => navigate('/dashboard'),
			permissions: [Permissions.Dashboard],
		},
		{
			key: menu_item_permission,
			icon: <img src={openKeys.includes(menu_item_permission) ? menuIconSystemActive : menuIconSystem} alt="" />,
			label: 'Permission',
			children: [
				{
					key: 'user',
					label: localize('userManagement'),
					onClick: () => navigate('/permission/user'),
					permissions: [Permissions.Users_LIST],
				},
				{
					key: 'role',
					label: localize('roleManagement'),
					onClick: () => navigate('/permission/role'),
					permissions: [Permissions.Roles_LIST],
				},
			],
		},
	];

	function isPermittedItem(item) {
		const itemPermissions = item.permissions;
		if (!itemPermissions) {
			// no permission check is required for this item
			return true;
		} else {
			// check if current logged-in user permissions includes the permission
			return itemPermissions.some((it) => permissions.includes(it));
		}
	}
	const permittedMenuItems = () => {
		const permittedItems = [];
		[...menuItems].forEach((menuItem) => {
			const subMenuItems = menuItem.children;
			if (!subMenuItems) {
				// no sub menu items
				if (isPermittedItem(menuItem)) {
					permittedItems.push({ ...menuItem });
				}
			} else {
				const permittedSubMenuItems = subMenuItems.filter(isPermittedItem);
				if (permittedSubMenuItems.length > 0) {
					const copiedMenuItem = { ...menuItem };
					copiedMenuItem.children = permittedSubMenuItems;
					permittedItems.push(copiedMenuItem);
				}
			}
		});

		return permittedItems;
	};

	return (
		<div className="sidebar-qaq" collapsible="false">
			<div className="sidebar-header">
				<img className="sidebar-title" src={RAQNLog} alt="" />
				<img alt="" src={projectsIcon} />
			</div>
			<Menu
				mode="inline"
				selectedKeys={[selectedKey]}
				openKeys={openKeys}
				onOpenChange={(keys) => setOpenKeys(keys)}
				className="sidebar-menu"
				items={permittedMenuItems()}
			/>
			<div style={{ position: 'absolute', bottom: 20, width: '100%', padding: '0 16px' }}></div>
		</div>
	);
};

export default Sidebar;
